import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import LengthRestrictions from "../../RouteDescription/LengthRestrictions";


export default function LengthListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };
  
  return(
    <>
      {props.roadFeatureResponse && 
      props.roadFeatureResponse.lengths && 
      props.roadFeatureResponse.lengths.length !== 0 && 
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Lengdebegrensninger (${props.roadFeatureResponse?.lengths.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <LengthRestrictions roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
        </>
      }
    </>
  )
}